import React,{Component} from 'react';
import {PostData} from '../../../service/postData';
import {sendNotification} from '../../../_notificationSettings/notificationPanel';
import validator from 'validator';
import { Editor, EditorTools, EditorUtils} from '@progress/kendo-react-editor';

const { Bold, Italic, Underline,
    AlignLeft, AlignRight, AlignCenter,
    Indent, Outdent,
    OrderedList, UnorderedList,
    Undo, Redo, Link, Unlink } = EditorTools;

let _sessionPeriod = true;
let _countrySession = localStorage.getItem('vs_UserCountrySession');
let _countryCode = 'IN';
if(_countrySession!=undefined || _countrySession!=null)
{
    _sessionPeriod = false;
    _countrySession = JSON.parse(_countrySession);
    _countryCode = _countrySession.countryCode;
}
global.BACK_URL = 'Business';

export default class blogAddPannel extends Component{
    constructor(props){
        super(props);
        this.state = {
            buttonTitle:'Add New',
            isLoaded : false,
            isLoggedin : false,
            countryCode: _countryCode,
            blogCatgeoryArray : [],
            countryArray: [],
            setup_plan_title : '',
            setup_plan_amount: '',
            description: '',
            country_id : '',
            setup_id:0,
            errors : {
                setup_plan_title : '',
                setup_plan_amount : '',
                description : '',
                country_id : '',
            }
        }
    }

    async componentDidMount()
    {
        
        let _handleParam = this.props.location.search;
        _handleParam = _handleParam.split('?auth=');
        let _setupId = _handleParam[1];
        let _userCountryId = "0";

        if(_setupId > 0){
            let _setupArray = [];
            let _url_GetData = global.setupPlanDetails+'?setupId='+_setupId;
            PostData(_url_GetData,'','GET').then(result => {
                let responseJson = result;
                if(responseJson.success == false)
                {  
                    this.setState({isLoaded:true});                
                }
                else
                {
                    if (responseJson.response) {
                        _setupArray = responseJson.response[0];
                        console.log("DD--",atob(_setupArray.setup_plan_description));
                        this.setState({buttonTitle:'Edit',setup_plan_title:(_setupArray.setup_plan_title),setup_plan_amount:(_setupArray.setup_plan_amount),country_id:(_setupArray.country_id),description:atob(_setupArray.setup_plan_description),isLoaded:true,setup_id: _setupArray.id});
                    }
                }             
            })
            .catch(error => this.setState({ error, isLoaded: false }));
        }
        
        let _urlCountryData = global.adminCountryList;
        let countryData = await PostData(_urlCountryData, "", "GET");
        let _conLang,
            _conFlag,
            _conName,
            _conPh,
            _conId = "";
        countryData.response.map((conty, i) => {
            let _name = conty.sortname.toLowerCase();
            let _imgPath = global.FLAG_URL + _name + ".png";
            //alert(_userCountryId+'-----'+_countryCode);
            if (_userCountryId > 0) {
            if (_userCountryId == conty.phonecode) {
                _conLang = conty.sortname;
                _conFlag = _imgPath;
                _conName = conty.name;
                _conPh = conty.phonecode;
                _conId = conty.id;
            }
            } else if (_countryCode == conty.sortname) {
            _conLang = conty.sortname;
            _conFlag = _imgPath;
            _conName = conty.name;
            _conPh = conty.phonecode;
            _conId = conty.id;
            }
        });
        console.log("==dd==",countryData.response);
        this.setState({
            countryArray: countryData.response,
            _countryId: _conId,
            _countryLang: _conLang,
            _countryFlag: _conFlag,
            _countryName: _conName,
            _countryPh: _conPh,
            isLoaded: true,
        });
    }

    getReadyMobileCode() {
        let data = [];
        if (this.state.isLoaded == true) {
        data = this.state.countryArray.map((conty, i) => {
            let _name = conty.sortname.toLowerCase();
            let _imgPath = global.FLAG_URL + _name + ".png";

            return (
            <li
                key={i}
                className="iti__country iti__standard"
                id="iti-item-in"
                onClick={this.selectCounties.bind(
                this,
                conty.phonecode,
                _imgPath,
                conty.sortname,
                conty.id
                )}
            >
                <div className="iti__flag-box">
                <div className="iti__flag" id="itiFlagImg">
                    <img src={_imgPath} />
                </div>
                </div>
                <span className="iti__country-name">{conty.sortname}</span>
                <span className="iti__dial-code">{conty.phonecode}</span>
            </li>
            );
        });
        }
        return data;
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;
        this.setState({isDisabled:false});
        switch (name) {
            case 'setup_plan_title': 
            errors.setup_plan_title = 
                value.length < 5 ? '*Setup plan title must be 5 characters long!' : '';
                this.setState({setup_plan_title:value}); 
            break;
            case "setup_plan_amount":
                if (validator.isFloat(value)) {
                    errors.setup_plan_amount = "";
                } else {
                    errors.setup_plan_amount = "*Enter numeric value only!";
                }
                this.setState({ setup_plan_amount: value });
                break;
            break;
            
            case 'description': 
                errors.description = 
                value.length < 10
                ? '*Description must be 10 characters long! '
                : '';
                this.setState({description:value}); 
            break;
                    
            case "country_id":
                errors.country_id =
                value.length < 0 ? "*Select country location!" : "";
                this.setState({ country_id: value });
            break;
            
            default:
            break;
        }
    }

    clickToAddSetupPlan = (event) => {
        event.preventDefault();
        let errors = this.state.errors;
        let _isError = false;
        if(this.state.setup_plan_title == '')
        {
            _isError = true;
            errors['setup_plan_title'] = "*Please enter setup plan title ";
            this.setState({errors: errors});
        }
        if(this.state.setup_plan_amount == '')
        {
            _isError = true;
            errors['setup_plan_amount'] = "*Please Enter setup plan amount.";
            this.setState({errors: errors});
        }   
        if (this.state.country_id == "") {
            _isError = true;
            errors["country_id"] =
                "*Please Select country location.";
            this.setState({ errors: errors });
        }
              

        if(_isError == false){
            this.getHtml();
        }
    }
    
    getHtml = () => {
        const view = this.editor.view;
        let value = EditorUtils.getHtml(view.state);
        value = Buffer.from(value).toString('base64');
        //this.setState({description:value});
        if(this.state.setup_id > 0){
            this.editSetupPlan(value);
        }
        else{
            this.addSetupPlan(value);
        }
    }

    onChangeFileUploadHandler=event=>{       
        let reader = new FileReader();
        let file = event.target.files[0];        
        let errors = this.state.errors;
        errors['image'] = '';
        reader.onloadend = () => {
        this.setState({
            image: file,
            errors: errors
            //imagePreviewUrl: reader.result
        });
        }
        reader.readAsDataURL(file);
    }

    addSetupPlan(descData){   
        const requestData = JSON.stringify({
            setup_plan_title: this.state.setup_plan_title,
            setup_plan_amount: this.state.setup_plan_amount,
            country_id: this.state.country_id,
            description : descData
        });         
        PostData(global.adminAddSetupPlan, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                sendNotification("Success Message 👍",result.message,"success");
                setTimeout(
                    () => {
                        window.location.href = global.webUrl+'administrator/setup-plan-list/';
                    }, 
                    Math.floor(Math.random() * 5000) + 1
                )
            }
            else
            {
                sendNotification("Error Message 😓",result.message,"danger");
                let errors = this.state.errors;
                errors['unit_name'] = result.message;
                this.setState({
                    errors:errors
                })
                return;
            }
        });
    }

    editSetupPlan(descData)
    {
        const requestData = JSON.stringify({
            setup_plan_title: this.state.setup_plan_title,
            setup_plan_amount: this.state.setup_plan_amount,
            country_id: this.state.country_id,
            setup_id: this.state.setup_id,
            description : descData
        });          
        PostData(global.adminEditSetupPlan, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                sendNotification("Success Message 👍",result.message,"success");
                setTimeout(
                    () => {
                        window.location.href = global.webUrl+'administrator/setup-plan-list/';
                    }, 
                    Math.floor(Math.random() * 5000) + 1
                )
            }
            else
            {
                sendNotification("Error Message 😓",result.message,"danger");
                let errors = this.state.errors;
                errors['unit_name'] = result.message;
                this.setState({
                    errors:errors
                })
                return;
            }
        });
    }

    loadContainer(){
        if(this.state.isLoaded == true){
            return(
                <Editor
                    tools={[
                        [ Bold, Italic, Underline ],
                        [ Undo, Redo ],
                        [ Link, Unlink ],
                        [ AlignLeft, AlignCenter, AlignRight ],
                        [ OrderedList, UnorderedList, Indent, Outdent ]
                    ]}
                    contentStyle={{ height: 160 }}
                    defaultContent={this.state.description}
                    ref={editor => this.editor = editor}
                />
            );
        }
    }
    render(){
        const {errors} = this.state;
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return(
            <React.Fragment>
                <div className="content">
                    <div className="content-header">
                        <div className="header-section">
                            <h1 className="content-heading">
                                <i className="gi gi-direction"></i>Add / Edit Setup Plan<br/>
                            </h1>
                        </div>
                    </div>
                    <nav className="breadcrumb push">
                        <a className="breadcrumb-item" href={global.webUrl+"administrator/dashboard/"}>Dashboard</a>
                        <a className="breadcrumb-item" href={global.webUrl+"administrator/setup-plan-list/"}>Setup Plan List</a>
                        <span className="breadcrumb-item active">Add / Edit Setup Plan </span>
                    </nav>
                    <div className="block">
                        <div className="block-header block-header-default">
                            <h3 className="block-title">Add / Edit Setup Plan</h3>
                        </div>

                        <div className="block-content">
                            <form method="post" id="form-login" className="webForm px-30">
                            <div className="form-group row">
                                    <div className="col-6">
                                        <div className="form-material open">
                                            <select
                                                className="form-control"
                                                id="country_id"
                                                name="country_id"
                                                onChange={this.handleChange}
                                            >
                                                <option value=""> Select Registered Location</option>
                                                {this.state.countryArray.map((item, index) => {
                                                let _sel = "";
                                                if (this.state.country_id == item.id) {
                                                    _sel = "selected";
                                                }
                                                return (
                                                    <option
                                                    key={index}
                                                    value={item.id}
                                                    selected={_sel}
                                                    >
                                                    {item.name}
                                                    </option>
                                                );
                                                })}
                                            </select>
                                            <label htmlFor="login-password">
                                                Registered Country{" "}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <span className="vs_error_txt">
                                                {errors.country_id.length > 0 && (
                                                <span className="error">
                                                    {errors.country_id}
                                                </span>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-material open">
                                            
                                            <input type="text" required="required" style={{display: 'inline-block',width:'80%'}} placeholder="Setup plan title" autoComplete="false" value={this.state.setup_plan_title} className="form-control" id="setup_plan_title" name="setup_plan_title" onChange={this.handleChange}/>
                                            <label htmlFor="login-username">Setup plan title <span className="text-danger">*</span></label>
                                            
                                        </div>
                                        <div id="meta_keyword-error" className="animated fadeInDown">{errors.setup_plan_title.length > 0 && <span className='error'>{errors.setup_plan_title}</span>}</div>
                                    </div>
                                    
                                </div>
                                
                                <div className="form-group row">
                                    <div className="col-12">
                                        <div className="form-material open">
                                            <input type="text" required="required" placeholder="Setup plan amount" autoComplete="false" value={this.state.setup_plan_amount} className="form-control" id="setup_plan_amount" name="setup_plan_amount" onChange={this.handleChange}/>
                                            <label htmlFor="login-password">Setup plan amount<span className="text-danger">*</span></label>
                                        </div>
                                        <div id="meta_desc-error" className="animated fadeInDown">{errors.setup_plan_amount.length > 0 && <span className='error'>{errors.setup_plan_amount}</span>}</div>
                                    </div>
                                    
                                </div>
                                <div className="form-group row">
                                    <div className="col-12">
                                        <label htmlFor="login-password">Setup Plan Description <span className="text-danger">*</span></label>
                                        {this.loadContainer()}
                                        <div id="description-error" className="animated fadeInDown">{errors.description.length > 0 && <span className='error'>{errors.description}</span>}</div>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <button type="submit" disabled={isDisabled} className="btn btn-sm btn-hero btn-alt-primary" onClick={this.clickToAddSetupPlan}>
                                    <i className="fa fa-check mr-5"></i> {this.state.buttonTitle} Setup Plan
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )    
    }
}